import React from "react";

import { checkStatus } from "../../../api";
import Track from "../../../track";

class DownloadApp extends React.Component {
  state = {
    developerEmail: "",
    appStatus: "building",
    errMessage: "",
    successMessage: "",
    assetlinks_url: "",
    emailDeveloperLoading: false,
    formValues: {}
  };
  componentDidMount() {
    this.checkStatus();
  }
  checkStatus = () => {
    checkStatus({ id: this.props.match.params.appId }).then(data => {
      if (data.status) {
        if (data.build_status)
          this.setState({
            appStatus: "ready-to-download",
            assetlinks_url: data.assetlinks_url,
            formValues: data
          });
        else {
          setTimeout(() => {
            this.checkStatus();
          }, 5000);
        }
      } else {
        this.setState({ loading: false, errMessage: data.error });
      }
    });
  };
  render() {
    const { formValues } = this.state;
    return (
      <div className="step-3 col-sm-12 m-auto">
        {this.state.appStatus === "building" ? (
          <div className="app-verify text-center">
            <img
              alt="Loading"
              src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
              className="w-25"
            />
            
          </div>
        ) : (
          ""
        )}
        {this.state.appStatus === "ready-to-download" ? (
          <div>
            <h3 className="text-center">Your App is ready to download</h3>
            <h6 className="mb-4 text-center">
              <a
                href="http://support.appmaker.xyz/publising-app/how-to-publish-android-app-in-playstore"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here
              </a>{" "}
              to get instructions for uplaod to store .
            </h6>
            {formValues.name ? <div className="appicon d-flex flex-row">
              <div className="flex-grow">
                <img src="images/logo.png" alt="" />
              </div>
              <h5 className="ml-3 my-auto">{formValues.name}</h5>
            </div> :""}
            <div className="app-download d-flex mt-5">
              <div className="android-icon">
                <i className="fab fa-android" />
              </div>
              <h5 className="my-auto flex-grow-1">APK</h5>
              <a
                href={formValues.apk_url}
                onClick={()=>{
                  Track.event({
                    category: "PWA2APK",
                    action: "Click",
                    label:"APK Download"
                  });
                }}
                className="btn btn-dark text-white mr-0 d-sm-block"
              >
                <i className="fas fa-download mr-3 ml-3" />
              </a>
            </div>

            <div className="app-download d-flex mt-5">
              <div className="source-icon">
                <i className="far fa-file-archive" />
              </div>
              <h5 className="my-auto flex-grow-1">Source code</h5>
              <a
                href={formValues.source_url}
                onClick={()=>{
                  Track.event({
                    category: "PWA2APK",
                    action: "Click",
                    label:"Source code Download"
                  });
                }}
                className="btn btn-dark text-white mr-0 d-sm-block"
              >
                <i className="fas fa-download mr-3 ml-3" />
              </a>
            </div>

            <div className="app-download d-flex mt-5">
              <div className="key-icon">
                <i className="fas fa-paperclip" />
              </div>
              <h5 className="my-auto flex-grow-1">Certificate</h5>
              <a
                href={formValues.key_url}
                onClick={()=>{
                  Track.event({
                    category: "PWA2APK",
                    action: "Click",
                    label:"Certificate"
                  });
                }}
                className="btn btn-dark text-white mr-0 d-sm-block"
              >
                <i className="fas fa-download mr-3 ml-3" />
              </a>
            </div>

            <div className="app-download text-left">
              <div className="table-prop">
                <table className="table">
                  <tbody>
                    <tr className="first-row">
                      <td>Alias</td>
                      <td>{formValues.cert.key_alias}</td>
                    </tr>
                    <tr>
                      <td>Store Password</td>
                      <td>{formValues.cert.store_pass}</td>
                    </tr>
                    <tr>
                      <td>Key Password</td>
                      <td>{formValues.cert.key_pass}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <a
                href={formValues.key_details_url}
                onClick={()=>{
                  Track.event({
                    category: "PWA2APK",
                    action: "Click",
                    label:"Key Details Download"
                  });
                }}
                className="btn btn-secondary text-white mr-0 d-sm-block"
              >
                <i className="fas fa-download mr-3 ml-3" /> Download
              </a>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default DownloadApp;
